var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhtBlueChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 69,
    viewBox: "0 0 97 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: "26.997%",
    cy: "20.685%",
    r: "111.803%",
    fx: "26.997%",
    fy: "20.685%",
    gradientTransform: "scale(.97778 1) rotate(62.916 .273 .212)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E5F2FC"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    stroke: "#26356C",
    d: "M53.806 60.739A9.296 9.296 0 0 0 66 62.46c-2.926-1.696-5.028-4.686-5.597-8.206C62.707 50.762 64.05 46.541 64.05 42c0-12.151-9.636-22-21.525-22C30.635 20 21 29.849 21 42s9.634 22 21.525 22c4.14 0 8.002-1.192 11.281-3.261z",
    transform: "translate(18 3)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#158CCC",
    d: "M33.982 42.255a19.136 19.136 0 0 1-4.955-2.219C27.469 41.855 25.186 43 22.637 43A8.28 8.28 0 0 1 18 41.6c2.655-1.545 4.549-4.255 5.062-7.455C20.973 30.964 19.77 27.127 19.77 23c0-11.055 8.708-20 19.469-20C48.195 3 55.735 9.2 58 17.673"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 81.5,
    cy: 4.5,
    r: 4.5,
    stroke: "#B3D9EE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 62,
    r: 3,
    fill: "#158CCC"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A6CBDF",
    strokeLinecap: "square",
    d: "M3.5 21.5v9M6.5 24.902h-6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#158CCC",
    strokeLinecap: "square",
    d: "M93.5 41.5v9M96.5 44.902h-6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhtBlueChat);
export default __webpack_public_path__ + "static/media/whtBlue-chat.168553db69bc065cf345d07c5689e6e1.svg";
export { ForwardRef as ReactComponent };